module.exports = __webpack_public_path__ + "img/06-5.39ca82a9.png";